import { useApolloClient } from "@apollo/client";
import { Auth } from "aws-amplify";
import { useEffect } from "react";

const BfCacheClearfix: React.FC = () => {
  const apollo = useApolloClient();

  useEffect(() => {
    const onPageShow = async ({ persisted }: PageTransitionEvent) => {
      if (!persisted) {
        return;
      }

      const user = await Auth.currentUserPoolUser().catch(() => null);

      if (user) {
        return;
      }

      await apollo.resetStore();
    };

    window.addEventListener("pageshow", onPageShow);

    return () => {
      window.removeEventListener("pageshow", onPageShow);
    };
  }, [apollo]);

  return null;
};

export default BfCacheClearfix;
